import React from 'react';
import { COMPREHENSION, getPillNameFromSkillOrStandard } from '../utils/skills';
import { WithTooltip } from './WithTooltip';
import { XMarkIcon } from '@heroicons/react/24/outline';

const getPillColor = (standard, disabled) => {
  if (standard.name === COMPREHENSION) {
    if (disabled) {
      return 'bg-emerald-50 text-emerald-700';
    }
    return 'bg-emerald-100 text-emerald-700';
  }

  if (disabled) {
    return 'bg-amber-100 text-amber-700';
  }
  return 'bg-amber-200 text-amber-800';
};

export const StandardPill = ({ standard, onClear, disabled, showToolTip = true }) => {
  if (!standard?.id) {
    return null;
  }

  const pill = (
    <div
      className={
        'flex w-fit text-center text-xs rounded-full font-medium whitespace-nowrap py-1 px-2 ' +
        (onClear ? 'cursor-pointer' : '') +
        ' ' +
        getPillColor(standard, disabled)
      }
      onClick={onClear}>
      {onClear && <XMarkIcon className='self-center h-3 w-3 mr-1' />}
      {getPillNameFromSkillOrStandard(standard)}
    </div>
  );

  return showToolTip ? (
    <WithTooltip
      text={
        standard.description.length > 40
          ? standard.description.substring(0, 40) + '...'
          : standard.description
      }
      position='top'
      showArrow={true}
      anchor='left'>
      {pill}
    </WithTooltip>
  ) : (
    pill
  );
};
